// This file is automatically generated. Do not edit manually.

import { ProjectState } from "src/api/generated/erp/db/types/enums/projectState";
import { ServerSideDataModelRequest } from "src/api/generated/common/dataGrids/serverSideDataModelRequest";
import { CostEventsOfObjectService_GridData } from "src/api/generated/erp/common/costEvents/service/costEventsOfObjectService";
import { ProjectActivityCostEventView } from "src/api/generated/erp/db/types/tables/projectActivityCostEventView";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace ProjectCostEventsDataGridsApi {
	export async function getGridDataForMultipleProjects(args: {
		projectIds: Array<number>;
		projectStates: Array<ProjectState>;
		dataModelRequest: ServerSideDataModelRequest;
	}): Promise<CostEventsOfObjectService_GridData<ProjectActivityCostEventView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/project/costEvents/getGridDataForMultipleProjects",
			method: "POST",
			data: {
				projectIds: args.projectIds,
				projectStates: args.projectStates,
				dataModelRequest: args.dataModelRequest,
			},
		});
		return response as CostEventsOfObjectService_GridData<ProjectActivityCostEventView>;
	}

	export async function getGridDataForProject(args: {
		projectId: number;
		dataModelRequest: ServerSideDataModelRequest;
	}): Promise<CostEventsOfObjectService_GridData<ProjectActivityCostEventView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/project/costEvents/getGridDataForProject",
			method: "POST",
			data: {
				projectId: args.projectId,
				dataModelRequest: args.dataModelRequest,
			},
		});
		return response as CostEventsOfObjectService_GridData<ProjectActivityCostEventView>;
	}

	export async function getGridDataForSubProject(args: {
		subProjectId: number;
		dataModelRequest: ServerSideDataModelRequest;
	}): Promise<CostEventsOfObjectService_GridData<ProjectActivityCostEventView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/project/costEvents/getGridDataForSubProject",
			method: "POST",
			data: {
				subProjectId: args.subProjectId,
				dataModelRequest: args.dataModelRequest,
			},
		});
		return response as CostEventsOfObjectService_GridData<ProjectActivityCostEventView>;
	}
}
